<template>
    <app-layout title="ZFO">

        <div class="pt-6 px-4 sm:px-6 md:px-8 space-y-6">
            <div>
                <div class="md:grid md:grid-cols-3 md:gap-6">
                    <div class="mt-5 md:mt-0 md:col-span-3">
                        <form method="POST">
                            <div class="shadow sm:rounded-md sm:overflow-hidden">
                                <div class="px-4 py-5 bg-white space-y-6 sm:p-6 md:grid md:grid-cols-3 md:gap-6">
                                    <div class="md:col-span-3">
                                        <h3 class="text-lg font-medium leading-6 text-gray-900">Otevřít ZFO</h3>
                                        <p class="mt-1 text-sm text-gray-500">
                                            Zde si můžete zobrazit stažený ZFO soubor. <i>Bude také ověřena pravost zprávy.</i>
                                        </p>
                                    </div>
                                    <div style="margin-top: 0;" class="md:col-span-3">
                                        <label class="block text-sm font-medium text-gray-700">
                                            Soubor
                                        </label>
                                        <div @dragover.prevent @drop.prevent="dropFile" @dragenter="fileDragover++" @dragleave="fileDragover--" :class="fileDragover ? 'border-indigo-300' : 'border-gray-300'" class="mt-2 flex justify-center px-6 pt-5 pb-6 border-2 border-dashed rounded-md hover:bg-gray-50">
                                            <div @dragenter="fileDragover++" @dragleave="fileDragover--" class="space-y-1 text-center">
                                                <svg @dragenter="fileDragover++" @dragleave="fileDragover--" class="mx-auto h-12 w-12 text-gray-400 float-left mr-4" stroke="currentColor" fill="none" viewBox="0 0 48 48" aria-hidden="true">
                                                    <path d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>
                                                <div @dragenter="fileDragover++" @dragleave="fileDragover--" class="flex text-sm text-gray-600">
                                                    <label @dragenter="fileDragover++" @dragleave="fileDragover--" for="file" class="relative cursor-pointer rounded-md font-medium text-indigo-600 hover:text-indigo-500 focus-within:outline-none">
                                                        <span @dragenter="fileDragover++" @dragleave="fileDragover--" >Vyberte</span>
                                                        <input @dragenter="fileDragover++" @dragleave="fileDragover--"  required v-on:change="handleFiles($event, 'open')" id="file" name="file" type="file" class="sr-only">
                                                    </label>
                                                    <p @dragenter="fileDragover++" @dragleave="fileDragover--" class="pl-1">nebo přetáhněte soubor</p>
                                                </div>
                                                <p @dragenter="fileDragover++" @dragleave="fileDragover--" class="text-xs text-gray-500">
                                                    ZFO, max. 50MB
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!--<div class="px-4 py-3 bg-gray-50 text-right sm:px-6">
                                    <primary-button @click.native="openZfo" type="button">
                                        Otevřít
                                    </primary-button>
                                </div>-->
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <jet-section-border/>

        <div :class="!features.includes('import') ? 'opacity-25' : ''" class="px-4 sm:px-6 md:px-8 space-y-6">
            <div>
                <div class="md:grid md:grid-cols-3 md:gap-6">
                    <div class="md:mt-0 md:col-span-3">
                        <form action="#" method="POST">
                            <div class="shadow sm:rounded-md sm:overflow-hidden">
                                <div class="px-4 py-5 bg-white sm:p-6 md:grid md:grid-cols-3 md:gap-6">
                                    <div class="md:col-span-3">
                                        <h3 class="text-lg font-medium leading-6 text-gray-900">Nahrát ZFO</h3>
                                        <p class="mt-1 text-sm text-gray-500">
                                            Nahrajte staré .zfo soubory a my Vám je, pokud projdou kontrolou, uložíme mezi ostatní zprávy a postaráme se o ně.
                                        </p>
                                    </div>

                                    <transition
                                        enter-active-class="transition ease-out duration-100"
                                        enter-from-class="transform opacity-0 scale-95"
                                        enter-to-class="transform opacity-100 scale-100"
                                        leave-active-class="transition ease-in duration-75"
                                        leave-from-class="transform opacity-100 scale-100"
                                        leave-to-class="transform opacity-0 scale-0"
                                    >
                                    <div v-if="status === uploaderStatuses.selecting" class="md:col-span-3" style="margin-top: 0;">
                                        <label class="block text-sm font-medium text-gray-700 sr-only">
                                            Soubory
                                        </label>
                                        <div @dragover.prevent @drop.prevent="dropFiles" @dragenter="filesDragover++" @dragleave="filesDragover--" :class="filesDragover ? 'border-indigo-300' : 'border-gray-300'" class="mt-2 flex justify-center px-6 pt-5 pb-6 border-2 border-dashed rounded-md hover:bg-gray-50">
                                            <div @dragenter="filesDragover++" @dragleave="filesDragover--" class="space-y-1 text-center">
                                                <svg @dragenter="filesDragover++" @dragleave="filesDragover--" class="mx-auto h-12 w-12 text-gray-400" stroke="currentColor" fill="none" viewBox="0 0 48 48" aria-hidden="true">
                                                    <path @dragenter="filesDragover++" @dragleave="filesDragover--" d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>
                                                <div @dragenter="filesDragover++" @dragleave="filesDragover--" class="flex text-sm text-gray-600">
                                                    <label :class="!features.includes('import') ? 'cursor-default' : 'cursor-pointer'" @dragenter="filesDragover++" @dragleave="filesDragover--" for="files" class="relative rounded-md font-medium text-indigo-600 hover:text-indigo-500 focus-within:outline-none">
                                                        <span @dragenter="filesDragover++" @dragleave="filesDragover--">Vyberte</span>
                                                        <input v-if="features.includes('import')" @dragenter="filesDragover++" @dragleave="filesDragover--" required v-on:change="handleFiles($event, 'import')" multiple id="files" name="files" type="file" class="sr-only">
                                                    </label>
                                                    <p @dragenter="filesDragover++" @dragleave="filesDragover--" class="pl-1">nebo přetáhněte soubory</p>
                                                </div>
                                                <p @dragenter="filesDragover++" @dragleave="filesDragover--" class="text-xs text-gray-500">
                                                    ZFO, každý max. 50MB
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    </transition>

                                    <div v-if="files.length > 0" class="md:col-span-3">
                                        <label class="block text-sm font-medium text-gray-700">
                                            Soubory k nahrání
                                        </label>
                                        <dd v-for="(file, index) in files" class="mt-1 text-sm text-gray-900">
                                            <ul class="border border-gray-200 rounded-md divide-y divide-gray-200">
                                                <li class="pl-3 pr-4 py-3 flex items-center justify-between text-sm hover:bg-gray-50">
                                                    <a class="w-0 flex-1 flex items-center">
                                                        <!-- Heroicon name: paper-clip -->
                                                        <svg class="flex-shrink-0 h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                                            <path fill-rule="evenodd" d="M8 4a3 3 0 00-3 3v4a5 5 0 0010 0V7a1 1 0 112 0v4a7 7 0 11-14 0V7a5 5 0 0110 0v4a3 3 0 11-6 0V7a1 1 0 012 0v4a1 1 0 102 0V7a3 3 0 00-3-3z" clip-rule="evenodd" />
                                                        </svg>
                                                        <span class="ml-2 flex-1 w-0 truncate">
                                                      {{ file.filename }}
                                                    </span>
                                                    </a>
                                                    <div v-if="file.status === statuses.short.waiting" class="ml-4 flex-shrink-0">
                                                        <a @click="" class="font-medium cursor-pointer">
                                                            <svg class="flex-shrink-0 h-5 w-5 text-gray-600 hover:text-gray-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                                                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clip-rule="evenodd" />
                                                            </svg>
                                                        </a>
                                                    </div>
                                                    <div v-if="file.status === statuses.short.uploading" class="ml-4 flex-shrink-0">
                                                        <a @click="" class="font-medium cursor-pointer">
                                                            <svg class="flex-shrink-0 h-5 w-5 text-blue-600 hover:text-blue-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                                                <path d="M5.5 13a3.5 3.5 0 01-.369-6.98 4 4 0 117.753-1.977A4.5 4.5 0 1113.5 13H11V9.413l1.293 1.293a1 1 0 001.414-1.414l-3-3a1 1 0 00-1.414 0l-3 3a1 1 0 001.414 1.414L9 9.414V13H5.5z" />
                                                                <path d="M9 13h2v5a1 1 0 11-2 0v-5z" />
                                                            </svg>
                                                        </a>
                                                    </div>
                                                    <div v-if="file.status === statuses.short.ok" class="ml-4 flex-shrink-0">
                                                        <a @click="" class="font-medium cursor-pointer">
                                                            <svg class="flex-shrink-0 h-5 w-5 text-green-600 hover:text-green-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                                                <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
                                                            </svg>
                                                        </a>
                                                    </div>

                                                    <div v-if="
                                                    file.status === statuses.short.unauthenticated
                                                    || file.status === statuses.short.no_account
                                                    || file.status === statuses.short.upload_error
                                                    || file.status === statuses.short.unauthorized
                                                    || file.status === undefined"
                                                         class="ml-4 flex-shrink-0">
                                                        <a v-tooltip="statuses.long[file.status === undefined ? statuses.short.upload_error : file.status]" @click="" class="font-medium cursor-pointer">
                                                            <svg class="flex-shrink-0 h-5 w-5 text-gray-600 hover:text-gray-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                                                <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd" />
                                                            </svg>
                                                        </a>
                                                    </div>
                                                    <div v-if="
                                                    file.status === statuses.short.unauthenticated
                                                    || file.status === statuses.short.no_account
                                                    || file.status === statuses.short.upload_error
                                                    || file.status === statuses.short.unauthorized
                                                    || file.status === undefined"
                                                         class="ml-1 flex-shrink-0">
                                                        <a @click="" class="font-medium cursor-pointer">
                                                            <svg class="flex-shrink-0 h-5 w-5 text-red-600 hover:text-red-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                                                <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                                                            </svg>
                                                        </a>
                                                    </div>

                                                    <div v-if="file.status === null" class="ml-4 flex-shrink-0">
                                                        <a @click="removeFile(index)" class="font-medium cursor-pointer">
                                                            <svg class="flex-shrink-0 h-5 w-5 text-red-600 hover:text-red-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                                                <path fill-rule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clip-rule="evenodd" />
                                                            </svg>
                                                        </a>
                                                    </div>
                                                </li>
                                            </ul>
                                        </dd>
                                    </div>

                                </div>
                                <div class="px-4 py-3 bg-gray-50 text-right sm:px-6">
                                    <primary-button @click.native="importZfo(0)" v-if="status !== uploaderStatuses.uploaded" :class="{ 'opacity-25': status !== uploaderStatuses.selecting, 'cursor-default' : !features.includes('import') }" :disabled="status !== uploaderStatuses.selecting || !features.includes('import')" type="button">
                                        Nahrát
                                    </primary-button>
                                    <secondary-button v-if="status === uploaderStatuses.uploaded" @click.native="reset" type="button">
                                        Zrušit
                                    </secondary-button>
                                    <button v-if="status === uploaderStatuses.uploaded" @click="confirmImport" type="button" class="ml-2 inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500">
                                        Potvrdit
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <p>&nbsp;</p>
        <p>&nbsp;</p>
        <p>&nbsp;</p>

    </app-layout>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout";
import JetSectionBorder from "@/Jetstream/SectionBorder";
import PrimaryButton from "@/Jetstream/Button";
import SecondaryButton from "@/Jetstream/SecondaryButton";
import { useToast } from "vue-toastification";

export default {
    name: "Zfo",
    components: {
        AppLayout,
        JetSectionBorder,
        PrimaryButton,
        SecondaryButton
    },
    data() {
        return {
            file: null,
            files: [],

            fileDragover: 0,
            filesDragover: 0,

            batch: null,
            successfulMessages: [],

            uploaderStatuses: {selecting: 0, uploading: 1, uploaded: 2},
            status: 0,
            statuses: this.$page.props.statuses,

            features: this.$page.props.features,
        }
    },
    setup(){
        const toast = useToast();
        return { toast }
    },
    methods: {
        openZfo(){
            this.$inertia.post(route('zfo.open'), this.file,{
                onSuccess: (response) => { if(response.props.alerts.length > 0) { this.toast.warning(response.props.alerts[0].text) } }
            });
        },
        confirmImport(){
            this.$inertia.post(route('importZfoConfirm'), {batch: this.batch, successfulMessages: this.successfulMessages})
        },
        importZfo(i = 0){
            if(this.files.length === 0) return;
            if(i === this.files.length) {
                this.status = this.uploaderStatuses.uploaded;
                return;
            }
            if(i === 0){
                this.status = this.uploaderStatuses.uploading;
                for(let j = 0; j < this.files.length; j++)
                    this.files[j].status = this.statuses.short.waiting;
            }
            this.files[i].status = this.statuses.short.uploading;

            axios.post(route('importZfo', {batch: this.batch}), {file: this.files[i]})
                .then(response => {
                    if(response.status === 200){
                        this.files[i].status = response.data.status;
                        if(this.files[i].status === this.statuses.short.ok) this.successfulMessages.push(response.data.messageId);
                        if(this.batch==null) this.batch = response.data.batch;
                        return this.importZfo(i + 1);
                    } else {
                        this.files[i].status = this.statuses.short.upload_error;
                        return this.importZfo(i + 1);
                    }
                })
                .catch(error => {
                    this.files[i].status = this.statuses.short.upload_error;
                    return this.importZfo(i + 1);
                });
        },
        handleFiles(event, type){
            if(type === 'openDrop' || type === 'importDrop') event = event.dataTransfer;
            else event = event.target;

            for(let i = 0; i < event.files.length; i++){
                const file = event.files[i];
                let filename = file.name;
                const fileReader = new FileReader();

                if(type === 'open' || type === 'openDrop'){
                    fileReader.addEventListener('load', () => {
                        this.file = { file: {content: fileReader.result, filename: filename} };
                        this.openZfo();
                    });
                } else { //import, importDrop
                    fileReader.addEventListener('load', () => {
                        this.files.push({content: fileReader.result, filename: filename, id: this.files.length + 1, status: null});
                    });
                }

                fileReader.readAsDataURL(file);
            }
        },
        reset(){
            this.files = [];
            this.file = null;
            this.status = this.uploaderStatuses.selecting;
            this.batch = null;
            this.successfulMessages = [];
        },
        dropFile(event){
            this.fileDragover = 0;
            this.handleFiles(event, 'openDrop');
        },
        dropFiles(event){
            if(!this.features.includes('import')) return;
            this.filesDragover = 0;
            this.handleFiles(event, 'importDrop')
        },
        removeFile(index){
            this.files.splice(index, 1);
        }
    }
}
</script>

<style scoped>

</style>
